import ADMIN_ACTIONS from "../actionTypes/admin_basic_actions";

const initialState = {
  BerPay_Admin: "",
};

const admin = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_ACTIONS.LOGIN_ERROR:
      return {
        ...state,
        BerPay_Admin: action.payload,
      };
    default:
      return { ...state };
  }
};

export default admin;
